export default __webpack_public_path__ + "static/media/flexline_logo_se.e77fc043.png";